import React from 'react';

import { withError } from '../../shared/components/error-boundary'
import { Helpers } from '../../core/src/helpers';

/*
 DEfault badge images based on products ksps
 */
const imgScr = {
    'gtx': 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/gtx1555526725499.jpg',
    'rtx': 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/rtx1555526725597.jpg'
};

export default withError(({
    badgeSrc,
    disableBadge,
    ksps = []
}) => {
    let imgUrl;
    const defaultImgParams = {
        imwidth: 150,
        impolicy: 'prdimg',
        imdensity: 1
    }
    if (badgeSrc) {
        imgUrl = typeof badgeSrc === 'string' ? badgeSrc : badgeSrc.src;
    } else {
        const [badge = ""] = ksps.filter(k => k.toLowerCase().indexOf('geforce') > -1);
        if (badge.toLowerCase().indexOf('gtx') > 0) {
            imgUrl = imgScr.gtx;
        } else if (badge.toLowerCase().indexOf('rtx') > 0) {
            imgUrl = imgScr.rtx;
        }
    }

    return imgUrl && !disableBadge ? (
        <span className="badge-container" >
            <img src={Helpers.addUrlParam(imgUrl, defaultImgParams, false)} />
        </span>
    ) : null;
})